import TemperatureRegulationPage from "../components/pages/temperatureregulationpage";

export default TemperatureRegulationPage;
